import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import MainSubHeading from "../Sub-Heading/MainSubHeading";
import FundRaising from "./fundRaising";
// import versanova from "../../assets/startups/";
import startup from "./startups.js"
import "./startups.css";
export default function Startups() {
  const subheadingData = "Startups";
  const subheadingData1 = "Funding opportunity for Startups";
  console.log(startup)
  return (
    <Container fluid="md">
      <MainSubHeading subheading={subheadingData1} />
      <FundRaising />
      <MainSubHeading subheading={subheadingData} />
      <Row>
        {
        startup && startup.map((index, key)=>{
          return(
            <Col xs={12} sm={6} md={6} lg={3}>
          <div className="p-2">
            <div className="startup-card p-2">
              <div className="startup-img p-3 py-1">
                <img src={index.startupLogo} alt="" className="img-fluid w-100" />
              </div>
              <h6>{index.startupName}</h6>
            </div>
          </div>
        </Col>
          )
})
}
      </Row>
    </Container>
  );
}
